export const ROLE_GESTOR_CONSULTA = "FG2_GESTOR_CONSULTA";

export const ROLE_GESTOR_ENVIO = "FG2_GESTOR_ENVIO";

export const ROLE_AGENTE_CONSULTA = "FG2_AGENTE_CONSULTA";

export const ROLE_AGENTE_ENVIO = "FG2_AGENTE_ENVIO";

export const ROLE_GERENCIAR_USUARIOS = "FG2_GERENCIAR_USUARIOS";

export const ROLE_GERENCIAR_AGENTES_FINANCEIROS = "FG2_GERENCIAR_AGENTES";

export const ROLE_CONSULTA_SCR = "FG2_CONSULTA_SCR";

export const ROLE_COTISTA_CONSULTA = "FG2_COTISTA_CONSULTA";

export const ROLE_DEPR_CONSULTA = "FG2_DEPR_CONSULTA";

export const ROLE_GESTOR_AVALIADOR_FGE = "FG2_GESTOR_AVALIADOR_FGE";
